module.exports = __webpack_public_path__ + "static/media/circle-notch.3cec8e7d.svg";